import React, {useState, useEffect, useRef, Component} from 'react';

import {t, dt} from 'l10n';

import '../../sass/modals/bankDetailsPopup.scss'
import {paymentOrderUpdate} from "../../backend-helpers/payment";
import 'sass/buyxxl.scss';

const BankDetailsPopup = ({ isOpen, onClose, orderDetails, user }) => {
    const [copiedField, setCopiedField] = useState(null);
    const inputRef = useRef(null);
    const [isNameSaved, setIsNameSaved] = useState(false);

    const bankDetails = {
        beneficiary: 'EURL ATTIKOS',
        domin: 'BPMED SAINT TROPEZ',
        IBAN: 'FR76 1460 7003 4960 8211 1908 696',
        BIC: 'CCBPFRPPMAR',
        purpose: `Payment for order #${orderDetails ? orderDetails.id : 'N/A'}`
    };

    const copyToClipboard = async (text, fieldName) => {
        try {
            await navigator.clipboard.writeText(text);
            setCopiedField(fieldName);
            setTimeout(() => setCopiedField(null), 2000);
        } catch (err) {
            console.error('Failed to copy text: ', err);
        }
    };

    const handleUpdateName = async () => {
        if (!inputRef.current.value) return;
        try {
            const updateResponse = await paymentOrderUpdate({id: orderDetails.id, name: inputRef.current.value});
            if (updateResponse && updateResponse.result && updateResponse.result.id === orderDetails.id) {
                setIsNameSaved(true);
                sessionStorage.setItem('paymentOrder', JSON.stringify(updateResponse.result));
            }
        } catch (error) {console.log(error);}
    }

    useEffect(() =>{
        const paymentSessionInfo = JSON.parse(sessionStorage.getItem('paymentOrder'))
        if (inputRef.current && paymentSessionInfo && paymentSessionInfo.name) {inputRef.current.value = paymentSessionInfo.name;}
    },[isNameSaved, copiedField])

    if (!isOpen || !orderDetails) return null;

    const BankDetailRow = ({ label, value, fieldName, copyable = true, red = false, sendable = false, placeholder }) => (
        <div className="bank-detail-row">
            <div className="bank-detail-label">{label}:</div>
            <div className="bank-detail-value">
                {sendable ? (
                    <input className={red ? 'redText' : ''} ref={inputRef} type="text" onBlur={handleUpdateName} onFocus={() => {
                        if (isNameSaved) {
                            setIsNameSaved(false)
                            setTimeout(() =>inputRef.current.focus(),100)
                        }
                    }}
                    placeholder={placeholder}
                    defaultValue={value}
                    />
                ) : (
                    <span className={red ? 'redText' : ''}>{value}</span>
                )}

                {copyable && (
                    <button
                        className={`copy-btn ${copiedField === fieldName ? 'copied' : ''}`}
                        onClick={() => copyToClipboard(value, fieldName)}
                        title="Copy to clipboard"
                    >
                        {copiedField === fieldName ? '✓' : '⧉'}
                    </button>
                )}

                {sendable && (
                    <button
                        className={`copy-btn confirm-btn ${isNameSaved ? 'copied' : ''}`}
                        onClick={handleUpdateName}
                        title="Send value"
                    >
                        {isNameSaved ? '✓' : dt('xxl', 'Confirm')}
                    </button>
                )}
            </div>
        </div>
    );

    const formatPaymentOptions = (inputText) => {
        if (!inputText) return '';

        const paymentPlans = {
            xxl60: dt('xxl', '%1 days of XXL', 60),
            xxl180: dt('xxl', '%1 days of XXL', 180),
            xxl365: dt('xxl', '%1 days of XXL', 365),
            wal220: dt('xxl', '%1 tokens', 220),
            wal600: dt('xxl', '%1 tokens', 600),
            wal1000: dt('xxl', '%1 tokens', 1000),
        };

        return inputText
            .split(',')
            .map((part) => paymentPlans[part] || part)
            .join(' + ');
    };

    return (
        <div className="bank-details-popup-overlay" onClick={onClose}>
            <div className="bank-details-popup" onClick={(e) => e.stopPropagation()}>
                <div className="popup-header">
                    <h2>{dt('xxl', 'Payment methods for your order by bank transfer, the steps to follow: ')}</h2>
                    <button className="close-btn" onClick={onClose}>
                        ×
                    </button>
                </div>

                <div className="popup-content">

                    <div className="bank-details-section">
                        <h3>{dt('xxl', 'Register the Eurl Attikos bank account with your bank')}</h3>
                        <BankDetailRow
                            label={dt('xxl', 'Beneficiary')}
                            value={bankDetails.beneficiary}
                            fieldName="beneficiary"
                        />
                        <BankDetailRow
                            label={dt('xxl', 'Domiciliation')}
                            value={bankDetails.domin}
                            fieldName="domiciliation"
                        />
                        <BankDetailRow
                            label={dt('xxl', 'IBAN')}
                            value={bankDetails.IBAN}
                            fieldName="iban"
                        />
                        <BankDetailRow
                            label={dt('xxl', 'BIC')}
                            value={bankDetails.BIC}
                            fieldName="bic"
                        />
                        <div className="amount-info">
                            <BankDetailRow
                                label={dt('xxl', 'Indicate your order number in the wording of your transfer')}
                                value={`T${orderDetails.id}`}
                                fieldName="purpose"
                                red
                            />
                        </div>

                        <BankDetailRow
                            label={dt('xxl', 'Account holder')}
                            placeholder={dt('xxl', 'Your first and last name')}
                            value={orderDetails.name || ''}
                            fieldName="name"
                            copyable={false}
                            sendable
                            red
                        />
                    </div>

                    <div className="amount-price">
                        {user && <i>{dt('xxl', 'Give to')} {user.nick}</i>}
                        <i>{formatPaymentOptions(orderDetails.type)}</i>
                        <strong>
                            {dt('xxl', 'Make a transfer of the amount of your order: ')}
                            {dt('xxl', '%1 €', orderDetails.amount)}
                        </strong>
                    </div>

                    <div className="instructions">
                        <ul>
                            <li>{dt('xxl', 'Your name remains confidential, no information is shared!')}</li>
                            <li>{dt('xxl', 'Your order will be processed within 6 hours of receipt of your transfer.')}</li>
                            <li>{dt('xxl', 'An instant transfer is preferred for rapid processing.')}</li>
                        </ul>
                    </div>

                    <PaymentFaqExtends />

                </div>
            </div>

        </div>
    );
};


const PaymentFaqExtends = () =>  {
    const [expanded, setExpanded] = React.useState(false);


        return (
            <div className={'buy-xxl'} style={{marginTop: 0, paddingTop: '0', paddingBottom: '0'}}>
                {dt('xxl', '')}


            <div className={'fonctionsXXL' + (expanded ? ' expanded' : '')} style={{paddingTop: '20px'}}>
                <div className="controls" onClick={() => setExpanded(!expanded)}>
                    <p>{dt('xxl', 'How to make an online bank transfer?')}</p>
                    <a className="toggle">
                        {expanded ? '−' : '+'}
                    </a>
                </div>
                <aside className="block-fonctions-xxl" style={{paddingTop: '20px'}}>
                    <div>
                        <p dangerouslySetInnerHTML={{__html: dt('xxl', 'Making an online transfer is a <strong>secure procedure!</strong>')}} />

                        <h3>{dt('xxl', '1. Connection')}</h3>
                        <p  dangerouslySetInnerHTML={{__html: dt('xxl', '<strong>Log in to your customer area:</strong> Go to your bank\'s website or open its mobile app, then enter your username and password.')}} />

                        <h3>{dt('xxl', '2. Addition of the Beneficiary: EURL ATTIKOS')}</h3>
                        <p>{dt('xxl', 'If this is your first time sending money to EURL ATTIKOS, you must first register it.')}</p>
                        <ol>
                            <li dangerouslySetInnerHTML={{__html: dt('xxl', '<strong>Access the Transfers section</strong>: Look for the tab or menu titled <strong>"Transfers"</strong>, <strong>"Transfers"</strong> or <strong>"Manage my beneficiaries"</strong>.')}}/>

                            <li dangerouslySetInnerHTML={{__html: dt('xxl', '<strong>Add a new beneficiary</strong>: Select the <strong>"Add a beneficiary"</strong> or <strong>"New beneficiary"</strong> option.')}}/>

                            <li dangerouslySetInnerHTML={{__html: dt('xxl', '<strong>Enter the information</strong>: Enter the IBAN below and the recipient\'s business name (company name): EURL ATTIKOS <br/> IBAN : <strong>FR76 1460 7003 4960 8211 1908 696</strong>')}}/>


                            <li>
                                <strong>{dt('xxl', 'Confirm the addition: ')}</strong>{dt('xxl', 'For security reasons, your bank will ask you to confirm this action. This is usually done via:')}
                                <ul style={{marginTop: '8px'}}>
                                    <li dangerouslySetInnerHTML={{__html: dt('xxl', 'A security code received by <strong>SMS</strong>.')}}/>
                                    <li dangerouslySetInnerHTML={{__html: dt('xxl', 'Validation on the mobile application (system type <strong>"SécuriPass"</strong> or biometric validation)')}}/>
                                </ul>
                            </li>
                        </ol>


                        <p dangerouslySetInnerHTML={{__html: dt('xxl', '<strong>Important:</strong> For a new beneficiary, a <strong>security period</strong> (often 24 to 48 hours) is sometimes applied before the first transfer can be made.')}}/>

                        <h3>{dt('xxl', '3. Execution of the Transfer')}</h3>
                        <p>{dt('xxl', 'Once the beneficiary is registered and activated (or if you select it from your list), you can make the transfer:')}</p>
                        <ol>
                            <li dangerouslySetInnerHTML={{__html: dt('xxl', '<strong>Initiate the one-time transfer</strong>: Return to the <strong>"Transfers"</strong> section and choose <strong>"One-time transfer"</strong> (for a one-time transaction).')}}/>

                            <li>
                                <strong>{dt('xxl', 'Select accounts:')}</strong>
                                <ul style={{marginTop: '8px'}}>
                                    <li dangerouslySetInnerHTML={{__html: dt('xxl', 'Choose the <strong>account to debit</strong> (your current account)')}}/>
                                    <li dangerouslySetInnerHTML={{__html: dt('xxl', 'Choose the <strong>account to credit</strong> (EURL ATTIKOS that you have just added or that you have selected).')}}/>

                                </ul>
                            </li>

                            <li><strong>{dt('xxl', 'Fill in the details:')}</strong>
                                <ul style={{marginTop: '8px'}}>
                                    <li dangerouslySetInnerHTML={{__html: dt('xxl', '<strong>Amount:</strong> Enter the amount you wish to transfer.')}}/>
                                    <li dangerouslySetInnerHTML={{__html: dt('xxl', '<strong>Execution Date:</strong> Leave today\'s date.')}}/>
                                    <li dangerouslySetInnerHTML={{__html: dt('xxl', '<strong>Label / Reason:</strong> Write <strong>your order number</strong>.')}}/>
                                    <li dangerouslySetInnerHTML={{__html: dt('xxl', '<strong>Check and confirm:</strong> A summary page will appear.')}}/>
                                    <li dangerouslySetInnerHTML={{__html: dt('xxl', '<strong>Validate the final transaction:</strong> Confirm the transfer again using the security code via SMS, the mobile app, or your personal code.')}}/>
                                </ul>
                            </li>


                        </ol>
                        <div/>
                        <p dangerouslySetInnerHTML={{__html: dt('xxl', 'The transfer is then transmitted. If it is a classic transfer (SEPA), the money usually arrives within <strong> one working day</strong>. If you choose the <strong>"Instant Transfer"</strong> option, the money is credited in less than 10 seconds.')}} />

                    </div>
                </aside>
</div>
            </div>
)
}

export default BankDetailsPopup;


// WEBPACK FOOTER //
// ./src/components/modals/BankDetailsPopup.js